export default "__VITE_ASSET__vxOiwxTI__"